var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "lesson-detail-user" },
    [
      _c(
        "v-list-item",
        { staticClass: "gap-4" },
        [
          _c(
            "v-list-item-avatar",
            { staticClass: "cursor-pointer" },
            [_c("v-icon", [_vm._v("groups")])],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-item-content",
            [
              _c("v-list-item-subtitle", [_vm._v("Students")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "flex pb-1",
                  class: { "flex-wrap": _vm.lesson.students.length },
                },
                [
                  _vm._l(_vm.lesson.students, function (student) {
                    return _c(
                      "div",
                      { key: student.id, staticStyle: { width: "30px" } },
                      [
                        _c(
                          "v-tooltip",
                          {
                            staticClass: "soli-round",
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-avatar",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass:
                                                "stacked-avatar shadow-md cursor-pointer",
                                              attrs: { size: "36" },
                                              on: {
                                                click: function ($event) {
                                                  _setup.selected = student
                                                  _setup.showContact = true
                                                },
                                              },
                                            },
                                            "v-avatar",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c("v-img", {
                                            attrs: {
                                              src: student.profile_photo_url,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(student.name))]),
                          ]
                        ),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  !_vm.lesson.cancelled &&
                  (!_vm.lesson.students.length ||
                    !Object.values(_vm.lesson.students).every(
                      (e) => e.attendance.status == "Teacher-cancel"
                    ))
                    ? _c("SoliBtn", {
                        staticClass: "pa-0.5 shadow-orange-xl",
                        attrs: {
                          icon:
                            _vm.lesson.students.length == 0 ? "add" : "edit",
                          round: "",
                          gradient: "gradient-orange",
                        },
                        on: {
                          click: function ($event) {
                            _setup.showManageEnrollment = true
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.lesson.students.length && _vm.lesson.cancelled
                    ? _c("v-icon", { staticClass: "pl-2 pa-0.5" }, [
                        _vm._v("block"),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _setup.showContact
        ? _c(_setup.LessonDetailContact, {
            attrs: {
              title: _setup.selected.name,
              contact:
                _setup.selected.relationships.filter((e) => !!e.email)[0] ??
                _setup.selected,
            },
            on: {
              reset: function ($event) {
                _setup.showContact = false
                _setup.selected = {}
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _setup.showManageEnrollment
        ? _c(_setup.ManageEnrollment, {
            attrs: { event: _vm.lesson },
            on: {
              reset: function ($event) {
                return _setup.reset()
              },
              success: function ($event) {
                return _setup.handleSuccess()
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }